export const SentryTag = {
  InngestFunction: "inngestFunction",
  App: "app",
  Source: "source",
  TrpcPath: "trpcPath",
  Runtime: "runtime",
} as const;

export const SentryApp = {
  Web: "web",
  Extension: "extension",
  Outreach: "outreach",
} as const;
